/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { makeStyles } from '@material-ui/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import { useNavigate } from 'react-router-dom';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import PersonIcon from '@mui/icons-material/Person';
import FamilyRestroomIcon from '@mui/icons-material/FamilyRestroom';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import SchoolIcon from '@mui/icons-material/School';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import UsbIcon from '@mui/icons-material/Usb';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import { LoadingButton } from '@material-ui/lab';
import BusinessIcon from '@mui/icons-material/Business';

import { Family } from './TabPages/Family';
import { Bank } from './TabPages/Bank';
import { Loan } from './TabPages/Loan';
import { Scholarship } from './TabPages/Scholarship';
import { Farming } from './TabPages/Farming';
import { FarmerAddEdit } from './TabPages/General';
import { IncomeAndAsset } from './TabPages/IncomeAndAsset';
import { CargillsConnect } from './TabPages/CargillsConnect';
import TokenDecoder from 'src/helpers/TokenDecoder';
import { SupplierProduce } from './TabPages/SupplierProduce';
import { ContactPerson } from './TabPages/ContactPerson';
import { Business } from './TabPages/Business';
import { Certification } from './TabPages/Certification';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#784af4',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#784af4',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  color: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#eaeaf0',
  display: 'flex',
  height: 22,
  alignItems: 'center',
  ...(ownerState.active && {
    color: '#784af4',
  }),
  '& .QontoStepIcon-completedIcon': {
    color: '#784af4',
    zIndex: 1,
    fontSize: 18,
  },
  '& .QontoStepIcon-circle': {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'currentColor',
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme, ownerState }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[700] : '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 50,
  height: 50,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  ...(ownerState.active && {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
    boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
  }),
  ...(ownerState.completed && {
    backgroundImage:
      'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
  }),
}));

const steps = ['Personal Details', 'Family Details', 'Sarubima', 'Bank Details', 'Loan Details', 'Farming Details', 'Income & Assets', 'Contact Person',
  'Supplier Produce Details', 'Business Details', 'Cargills Connect', 'Certification'];

export default function CustomizedSteppers() {
  const navigate = useNavigate();
  const [factoryType, setFactoryType] = useState(0);
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [farmerId, setFarmerID] = useState();
  const [farmerCollectionCenterID, setFarmerCollectionCenterID] = useState();
  const [isActiveComplete, setIsActiveComplete] = useState(false);

  useEffect(() => {
    setFactoryType(parseInt(TokenDecoder.getFactoryTypeFromToken()))
  }, []);
  function ColorlibStepIcon(props) {
    const { active, completed, className, stepIndex, onClick } = props;

    const icons = {
      1: <PersonIcon />,
      2: <FamilyRestroomIcon />,
      3: <SchoolIcon />,
      4: <AccountBalanceIcon />,
      5: <CreditScoreIcon />,
      6: <AgricultureIcon />,
      7: <AttachMoneyIcon />,
      8: <PermContactCalendarIcon />,
      9: <LocalMallIcon />,
      10: <BusinessIcon />,
      11: <UsbIcon />,
      12: <DocumentScannerIcon />,
    };

    const handleClick = () => {
      if (onClick) {
        onClick();
      }
    };

    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
        onClick={handleClick}
      >
        {icons[String(props.icon)]}
      </ColorlibStepIconRoot>
    );
  }

  ColorlibStepIcon.propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    completed: PropTypes.bool,
    icon: PropTypes.node,
    stepIndex: PropTypes.number,
    onClick: PropTypes.func,
  };

  const handleStepClick = (stepIndex) => {
    if (farmerId == undefined || farmerId == 0) {
      if (activeStep === 0) {
        return;
      }
      if (activeStep === 7) {
        setIsActiveComplete(true);
        setActiveStep(stepIndex);
      }
      setIsActiveComplete(false);
      setActiveStep(stepIndex);
    }
    else {
      setIsActiveComplete(false);
      setActiveStep(stepIndex);
    }
  };


  function getStepContent(step) {
    switch (step) {
      case 0:
        return <FarmerAddEdit handleNext={handleNext} handleBack={handleBack} setFarmerID={setFarmerID} setFarmerCollectionCenterID={setFarmerCollectionCenterID} />;
      case 1:
        return <Family handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} />;
      case 2:
        return <Scholarship handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} />;
      case 3:
        return <Bank handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} />;
      case 4:
        return <Loan handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} />;
      case 5:
        return <Farming handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} />;
      case 6:
        return <IncomeAndAsset handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} />;
      case 7:
        return <ContactPerson handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} />;
      case 8:
        return <SupplierProduce handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} />;
      case 9:
        return <Business handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} />;
      case 10:
        return <CargillsConnect handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} />;
      case 11:
        return <Certification handleNext={handleNext} handleBack={handleBack} farmerId={farmerId} handleFinish={handleFinish} />;
      default:
        return <>sorry</>
    }
  }

  const handleNext = () => {
    setIsActiveComplete(false);
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setIsActiveComplete(false);
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  function timeout(delay) {
    return new Promise(res => setTimeout(res, delay));
  }

  const handleFinish = () => {
    setIsActiveComplete(true);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  async function navigateToListing() {
    navigate('/dashboard/farmer');
    await timeout(300)
    toast.success("Farmer Saved Successfully")
  }

  return (
    <Stack sx={{ width: '100%' }} spacing={4}>
      <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel onClick={() => handleStepClick(index)} StepIconComponent={ColorlibStepIcon}>
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <div>
        {activeStep === steps.length ? (
          <div>
            <Typography className={classes.instructions}>
              All steps completed - you&apos;re finished
            </Typography>
            <Button onClick={handleReset} className={classes.button}>
              Reset
            </Button>
          </div>
        ) : (
          <div>
            <Typography className={classes.instructions}>{getStepContent(activeStep)}</Typography>
            {factoryType == 1 || factoryType == 3 ? null :
              <Stack direction={{ xs: 'column', sm: 'row' }} style={{ marginTop: '20px', marginRight: '25px' }} justifyContent="right" spacing={2} >
                {isActiveComplete ?
                  <LoadingButton
                    size="medium"
                    type="button"
                    variant="contained"
                    color='secondary'
                    onClick={navigateToListing}
                  >
                    Complete
                  </LoadingButton> : null}
              </Stack>}
          </div>
        )}
      </div>
    </Stack>
  );
}
